const list = {
  requestFail: 'Ops! Não conseguimos processar sua solicitação',
  waitingResponseRequest: 'Aguarde que estamos preparando as coisas...',
  warningMigrationUser: 'Caso este usuário já esteja cadastrado e ativo no seu IMOB, os clientes e imóveis desta migração serão vinculados a ele. A verificação será feita utilizando o campo e-mail.',
  warningZipcode: 'A informação do endereço será validada pelo sistema IMOB ao término da migração, estando sujeita a alteração em caso do CEP ser diferente do endereço informado ou a não existência do CEP no sistema.',
};

module.exports = list;
